<template>
  <v-slide-y-transition mode="out-in">                                    
    <v-layout row wrap>
     <v-flex lg5 sm5>
         <v-card pa-0>
           <v-toolbar card color="white">
             <v-text-field
             flat
             solo
             prepend-icon="search"
             placeholder="Type something"
             v-model="available.search"
             hide-details
             class="hidden-sm-and-down"
             ></v-text-field>                                                    
           </v-toolbar>
           <v-divider></v-divider>
           <v-card-text class="pa-0">
             {{updateInit}}
             <v-data-table
               :headers="available.headers"
               :search="available.search"
               :items="available.items"
               :loading="loading"
               :pagination.sync="pagination"
               :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
               class="elevation-1"
               item-key="name"
               select-all                
               v-model="available.selected"
               >
               <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
               <template slot="items" slot-scope="props">
               <td style="width:1px">
                 <v-checkbox
                   primary
                   hide-details
                   v-model="props.selected"
                 ></v-checkbox>
               </td>                     
                 <td>
                     <v-chip label text-color="white"  :color="color[props.item.type]">
                     {{ props.item.type }}
                     </v-chip>
                 </td>
                 <td>{{ props.item.name }}</td>                  
               </template>
             </v-data-table>
           </v-card-text>
         </v-card>
     </v-flex>  
     <v-flex lg2 sm2>
         <v-btn block :loading="loading" color="success" @click="assign()" dark>Assign >></v-btn>
         <v-btn block :loading="loading" color="warning" @click="remove()" dark><< Cancel</v-btn>
     </v-flex>
     <v-flex lg5 sm5>
         <v-card pa-0>
           <v-toolbar card color="white">
             <v-text-field
             flat
             solo
             prepend-icon="search"
             placeholder="Type something"
             v-model="assigned.search"
             hide-details
             class="hidden-sm-and-down"
             ></v-text-field>                                                  
           </v-toolbar>
           <v-divider></v-divider>
           <v-card-text class="pa-0">
             <v-data-table
               :headers="assigned.headers"
               :search="assigned.search"
               :items="assigned.items"
               :loading="loading"
               :pagination.sync="pagination"
               :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
               class="elevation-1"
               item-key="name"
               select-all                
               v-model="assigned.selected"
               >
               <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
               <template slot="items" slot-scope="props">
               <td style="width:1px">
                 <v-checkbox
                   primary
                   hide-details
                   v-model="props.selected"
                 ></v-checkbox>
               </td>                  
                 <td>
                     <v-chip label text-color="white"  :color="color[props.item.type]">
                     {{ props.item.type }}
                     </v-chip>
                 </td>
                 <td>{{ props.item.name }}</td>

               </template>
             </v-data-table>
           </v-card-text>
         </v-card>
     </v-flex>  
     </v-layout>                                                    
                        
           
  </v-slide-y-transition>
</template>
<script>     
import Assignment from '@/apps/main/models/rbac/Assignment';
import moment from 'moment';

var model = new Assignment();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({        
        valid:true,
        active: null,
        pagination:{},
        isUpdate:false, 
        color : {
            role:'teal',
            permission:'cyan',
            route:'grey'
        },
        formModel: {
            id: null,
            username:null,
            email:null,
        },
        available  : {
            search : '',
            selected: [],
            headers: [              
                { text: 'Type', value: 'type', align:'left'}, 
                { text: 'Name', value: 'name', align:'left'},                            
            ],
            items: []
        },
        assigned : {
            search  : '',
            selected: [],
            headers: [              
                { text: 'Type', value: 'type', align:'left'}, 
                { text: 'Name', value: 'name', align:'left'},                            
            ],
            items: []
        },
        loading  : true,
    }),
    computed:{
        updateInit(){          
          this.init();
          return;
        }
    },   
    created () {},    
    mounted () {
        this.init();        
    }, 
    methods : {
        
        
        init(){            
            if(this.$route.query.id){
                this.loading = true;
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                    
                    Object.assign(this.formModel, data === null ? {}:data.user);                                                                                                                                 
                    this.getView();
                    this.loading = false;
                });                                               
            }            
            this.$validator.localize('en', this.dictionary);       
        },
        
        getView(){
            model.view({id:this.formModel.id}).then(data=>{   
                var data = data.data;
                this.available.items = [];
                this.assigned.items = [];
                for(var key in data.available){                
                    this.available.items.push({name:key, type:data.available[key]});
                }  
                for(var key in data.assigned){                
                    this.assigned.items.push({name:key,type:data.assigned[key]});
                }  
                this.loading = false;
            })
        },
        
        assign(){
            var arr = [];
            this.available.selected.forEach((item)=>{
                arr.push(item.name);
            });
            this.loading = true;
            model.assign({items:arr}, {id:this.formModel.id}).then(data =>{                
                this.init();
            });
        },
                
        remove(){
            var arr = [];
            this.assigned.selected.forEach((item)=>{
                arr.push(item.name);
            });
            this.loading = true;
            model.remove({items:arr}, {id:this.formModel.id}).then(data =>{                
                this.init();
            });
        },
    }
}
</script>